import Dexie from 'dexie'

type DexieAuthType = {
  is_admin: boolean
  is_signed_in: boolean
  role: number
  brand_id: string | undefined
  shop_id: string | undefined
  store_id: string | undefined
  uid: string
}

interface DexieStore extends Dexie {
  appVersion: Dexie.Table<{ version: number }, number>
  auth: Dexie.Table<DexieAuthType, string>
}

const dexieDb = new Dexie('ReactReduxDB') as DexieStore

dexieDb.version(4).stores({
  appVersion: 'version',
  auth: 'uid, is_admin, is_signed_in, role, brand_id, shop_id, store_id',
})

export default dexieDb
